<template>
    <CustomHeader :text="$t('activityName.active_bonus')" />
    <div class="mainContainer">
        <div class="banner">
            <img v-if="dataSet.flatIcon" :src="dataSet.flatIcon" alt="">
            <img v-else src="@/assets/activeBonus/active_bonus_top_banner.png" alt="">
            <div class="yesterdayCard">
                <van-row>
                    <van-col span="16">
                        <div class="text1">{{ $t('chest.yesterdayBet') }} R$ {{ dataSet.yesterBetAmount }}</div>
                        <div class="text2">{{ $t('chest.bonus') }} R$ <span>{{ dataSet.yesterRewardAmount }}</span></div>
                    </van-col>
                    <van-col span="8" class="claimBtn">
                        <img v-if="dataSet.yesterRewardAmount <= 0" src="@/assets/activeBonus/active_bonus_item_disable.png"
                            alt="">
                        <div v-else class="activeClaimBtn" @click="activeBonusClaim">{{ $t('activity.reciev') }}</div>
                    </van-col>
                </van-row>
            </div>
        </div>
        <div class="todayCard">
            <div class="subtodayCard">
                <van-row>
                    <van-col span="16">
                        <div class="text1">{{ $t('chest.todayBet') }} R$ {{ dataSet.todayBetAmount }}</div>
                        <div class="text2">{{ $t('chest.bonus') }} R$ <span>{{ dataSet.todayRewardAmount }}</span></div>
                    </van-col>
                </van-row>
            </div>
            <van-row class="infoContainer">
                <van-col span="2" style="text-align: right; padding: 0 1%;">
                    <van-icon name="info" color="#fff" size="18" />
                </van-col>
                <van-col span="22">
                    {{ $t('chest.info',{startTime: dataSet.activityConfig?.claim_start_time, endTime: dataSet.activityConfig?.claim_end_time}) }}
                </van-col>
            </van-row>
        </div>
        <div class="bonusList">
            <div class="listTitle">{{ $t('chest.activeBonusTitle') }}</div>
            <van-row class="tabelhead">
                <van-col span="10">{{ $t('common.bets') }}</van-col>
                <van-col span="14">{{ $t('chest.luckBonus') }}</van-col>
            </van-row>
            <van-row v-for="(item, index) in dataSet.rewardList" :key="index" class="tabelRow" :style="{
                backgroundColor: index % 2 === 1 ? ' rgba(255, 255, 255, 0.02)' : 'rgba(255, 255, 255, 0.04)'
            }">
                <van-col span="10" class="tabelText">R$ {{item.bet }}</van-col>
                <van-col span="14" class="tabelText"><span>R$</span>{{ item.reward_coin }}</van-col>
            </van-row>
        </div>
        <div class="bottom_text">
            <van-row style="padding-bottom: 10px;">
                <van-col span="6" class="">
                    <div class="line1"></div>
                </van-col>
                <van-col span="12" class="title">
                    <div>{{ $t("common.activityTitle") }}</div>
                </van-col>
                <van-col span="6" class="">
                    <div class="line2"></div>
                </van-col>
            </van-row>
            <div class="line_text" v-for="(item, index) in dataSet.activityIntro" :key="index">
                {{ item }}
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import { defineEmits, defineProps } from 'vue';
import CustomHeader from '../components/common/customHeader.vue';
import { ActiveBonusData } from '@/view/activeBonus/supportScript';

const props = defineProps<{
  dataSet: ActiveBonusData
}>()

const emits = defineEmits(['activeBonusClaim'])

const activeBonusClaim = () => {
   emits('activeBonusClaim')
}
</script>
<style scoped>
.mainContainer {
    padding: 50px 0;
}

.banner {
    position: relative;
}

.banner img {
    width: 100%;
}

.yesterdayCard {
    background-image: linear-gradient(175deg, #fca1e8 0%, #8150d6 100%);
    padding: 10px;
    border-radius: 10px;
    border: 2px solid #e4dfdf;
    position: absolute;
    bottom: -20%;
    right: 5%;
    left: 5%;
}

.todayCard {
    width: 80%;
    margin: 12% 5% 2%;
    padding: 5%;
    background: #292a2d;
    border: 2px solid #ffcea6;
    border-radius: 10px;
}

.subtodayCard {
    width: 90%;
    padding: 5%;
    background-image: linear-gradient(105deg, rgba(209, 127, 255, 0.50) 0%, rgba(127, 153, 255, 0.50) 100%);
    border-radius: 10px;
}

.text1 {
    font-size: 15px;
    color: #fff;
    padding: 3.5% 5%;

}

.text2 {
    font-size: 15px;
    color: #fff;
    padding: 3.5% 5%;
    font-weight: bold;
}

.text2 span {
    font-size: 18px;
    color: yellow;
}

.claimBtn {
    display: flex;
    align-items: center;
}

.claimBtn img {
    width: 100%;
}

.activeClaimBtn {
    padding: 10%;
    border-radius: 30px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-image: linear-gradient(180deg, rgb(248, 216, 167) 0%, #f0a853 100%);
    width: 100%;
    display: flex;
    color: #292a2d;
    align-items: center;
    justify-content: center;
    font-size: 14px;
}

.infoContainer {
    padding: 10px 0;
    color: #ffffffa8;
    font-size: 11.5px;
}

.bonusList {
    padding: 2% 5%;
    color: #fff;
}

.listTitle {
    padding: 15px;
    background-image: linear-gradient(140deg, rgb(255 255 255 / 39%) 0%, #ffffff00 100%);
    border-radius: 15px 15px 0px 0;
    font-size: 14px;
    font-weight: bold;
    border-bottom: 1px solid #ffffff26;
}

.tabelhead {
    background-color: #ffffff38;
    padding: 15px;
    font-weight: bold;
    font-size: 13px;
}

.tabelRow {
    padding: 15px;
    font-size: 12px;
}

.tabelText {
    padding: 0 10px;
}

.tabelText span {
    padding: 0 5px;
    color: #ffffff4f;
}

.bottom_text {
    padding: 35px 25px 25px;
}

.line1 {
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    height: 2px;
    margin: 8px 0 0 0;
}

.line2 {
    transform: scaleX(-1);
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    height: 2px;
    margin: 8px 0 0 0;
}

.title {
    color: rgba(255, 255, 255, 0.85);
    font-size: 15px;
    display: flex;
    justify-content: center;
}

.line_text {
    color: rgba(255, 255, 255, 0.45);
    font-size: 14px;
    padding: 10px;
}

@media (min-width:350px) {}

@media (min-width: 600px) {}

@media (min-width: 1920px) {}
</style>